export default "__VITE_ASSET__8f74a3d8__$_?nuxt_component=async&nuxt_component_name=SvgoEnvelop__"